import { render, staticRenderFns } from "./PCG-CSFM.vue?vue&type=template&id=ce275e0a&scoped=true&"
import script from "./PCG-CSFM.vue?vue&type=script&lang=js&"
export * from "./PCG-CSFM.vue?vue&type=script&lang=js&"
import style0 from "./PCG-CSFM.vue?vue&type=style&index=0&id=ce275e0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce275e0a",
  null
  
)

export default component.exports